import React, { useState } from 'react';
import './SettingsTab.css';
import * as XLSX from 'xlsx';
import { format } from 'date-fns';

const SettingsTab = ({ settings, onUpdateSettings, onClearData, data }) => {
  const [groupsInput, setGroupsInput] = useState(settings.groups.join(', '));
  const [currencyInput, setCurrencyInput] = useState(settings.currency);

  const handleSaveSettings = () => {
    const groups = groupsInput.split(',').map(g => g.trim()).filter(g => g);
    
    if (groups.length < 1) {
      alert('At least one group is required');
      return;
    }

    onUpdateSettings({
      groups,
      currency: currencyInput
    });

    alert('Settings updated successfully!');
  };

  const handleExportToExcel = () => {
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }

    const ws = XLSX.utils.json_to_sheet(data.map(entry => ({
      Date: format(new Date(entry.date), 'yyyy-MM-dd'),
      Group: entry.group,
      'Time Group': entry.time_group,
      'Total Calculated': entry.total_calculated,
      'Font Caisse': entry.font_caisse,
      'Total Credit': entry.total_credit,
      'Total Achat': entry.total_achat,
      'Total Journal': entry.total_journal,
      'Total Calculated Formula': entry.total_calculated_formula,
      'Difference': entry.difference,
      'Daily Revenue': entry.daily_revenue,
      Notes: entry.notes || ''
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Revenue Data');
    
    const filename = `coffee_shop_data_export_${format(new Date(), 'yyyyMMdd')}.xlsx`;
    XLSX.writeFile(wb, filename);
    alert(`Data exported to ${filename}`);
  };

  return (
    <div className="settings-tab">
      <h2>Application Settings</h2>

      <div className="settings-section">
        <h3>Configuration</h3>
        
        <div className="setting-item">
          <label>Group Names (comma separated):</label>
          <input
            type="text"
            value={groupsInput}
            onChange={(e) => setGroupsInput(e.target.value)}
            placeholder="Group A, Group B"
            className="setting-input"
          />
        </div>

        <div className="setting-item">
          <label>Currency Symbol:</label>
          <input
            type="text"
            value={currencyInput}
            onChange={(e) => setCurrencyInput(e.target.value)}
            placeholder="€"
            className="setting-input"
            maxLength="5"
          />
        </div>

        <button onClick={handleSaveSettings} className="btn btn-primary">
          Save Settings
        </button>
      </div>

      <div className="settings-section">
        <h3>Data Management</h3>
        
        <div className="data-actions">
          <button onClick={handleExportToExcel} className="btn btn-secondary">
            Export Data to Excel
          </button>
          <button onClick={onClearData} className="btn btn-danger">
            Clear All Data
          </button>
        </div>

        <div className="data-info">
          <p><strong>Total Entries:</strong> {data.length}</p>
          {data.length > 0 && (
            <p>
              <strong>Data Range:</strong>{' '}
              {format(new Date(Math.min(...data.map(d => new Date(d.date)))), 'yyyy-MM-dd')} to{' '}
              {format(new Date(Math.max(...data.map(d => new Date(d.date)))), 'yyyy-MM-dd')}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsTab;

